"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetProgressCounter = resetProgressCounter;
exports.default = progress;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function statuses() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var status = arguments.length > 1 ? arguments[1] : undefined;
  var progressId = arguments.length > 2 ? arguments[2] : undefined;
  return Object.assign({}, state, _defineProperty({}, progressId, status ? 'loaded' : 'loading'));
}

var activeProgresses = 0;

function resetProgressCounter() {
  activeProgresses = 0;
}

var initialState = {
  isActive: false,
  fetchStatus: {}
};

function progress() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (action.progressId) {
    var status = state.fetchStatus[action.progressId];
    activeProgresses += status ? -1 : 1;
    return {
      isActive: activeProgresses !== 0,
      fetchStatus: statuses(state.fetchStatus, status, action.progressId)
    };
  }

  return state;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-progress/es/reducer.js
// module id = 1064
// module chunks = 0